export default function (query) {
    let params = {};
    const parametrosQuery = query.split("?")[1];

    if (parametrosQuery) {
        const listaDeParametros = parametrosQuery.split("&")

        for (var i = 0; i < listaDeParametros.length; i++) {
            var parametro = listaDeParametros[i].split("=");
            var chave = parametro[0];
            var valor = parametro[1];
            params[chave] = valor;
        }
    }

    return params;
}